import * as React from 'react';
import './loginmodal.css';
import KillPageStore from "../../fbobjects/KillPageStore";
export default class LoginModalC extends React.Component<any,any> {

    constructor(){
        super();
        this.state = {
            inputValue:'',
        }
    }

    handleSaveUsername(){
        KillPageStore.actionSetUsername(this.state.inputValue)
    }

    handleOnInputChange(e){
        this.setState({inputValue:e.target.value});
    }

    handleOnEnterInput(e){
        if (e.key == "Enter" && this.searchTextNotNull()){
            KillPageStore.actionSetUsername(this.state.inputValue)
        }
    }

    searchTextNotNull(){
        if (this.state.inputValue != "" && this.state.inputValue != null) return true;
        return false;
    }

    render(){

        return(

            <div>
                <div className="login-modal-container">
                    <div className="title">
                        Enter your Discord name
                    </div>
                    <div className="input-container">
                        <input className="input-username" onChange={(e)=>this.handleOnInputChange(e)} onKeyDown={(e)=>this.handleOnEnterInput(e)}/>
                    </div>
                    <div className="buttons-container">
                        <button disabled={!this.searchTextNotNull()} className="save-button" onClick={()=>this.handleSaveUsername()}>SAVE</button>
                    </div>
                </div>
                <div className="backdrop">

                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/LoginModalC/index.tsx